/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Track } from './Track';
import {
    TrackFromJSON,
    TrackFromJSONTyped,
    TrackToJSON,
} from './Track';

/**
 * 
 * @export
 * @interface TrackSearch
 */
export interface TrackSearch {
    /**
     * 
     * @type {Array<Track>}
     * @memberof TrackSearch
     */
    data?: Array<Track>;
}

/**
 * Check if a given object implements the TrackSearch interface.
 */
export function instanceOfTrackSearch(value: object): value is TrackSearch {
    let isInstance = true;

    return isInstance;
}

export function TrackSearchFromJSON(json: any): TrackSearch {
    return TrackSearchFromJSONTyped(json, false);
}

export function TrackSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TrackFromJSON)),
    };
}

export function TrackSearchToJSON(value?: TrackSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TrackToJSON)),
    };
}

